// src/components/Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer
      className="w-full text-white py-8 px-6 text-center bg-blue-900 bg-cover bg-center relative"  // py-8 for thinner height
      style={{
        backgroundImage:
          "linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.8)), url('/images/hero/momestate132.jpg')",
      }}
    >
      <div className="relative z-10 max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold mb-2">
          Patent-pending · Powered by <span className="text-blue-200 font-extrabold">ScucciDEBORAH</span>
        </h2>
        {/* Footer links */}
        <div className="mt-2 mb-2 flex flex-wrap items-center justify-center gap-4 text-base md:text-lg">
          <a href="/" className="text-blue-200 hover:underline">Home</a>
          <span className="opacity-40">•</span>
          <a href="https://scuccisystems.com/blog" className="text-blue-200 hover:underline">Blog</a>
          <span className="opacity-40">•</span>
          <a href="https://scuccisystems.com/blog/faq" className="text-blue-200 hover:underline">FAQ</a>
          <span className="opacity-40">•</span>
          <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-200 hover:underline"
          >
            Terms of Service
          </a>
        </div>
        <p className="max-w-2xl mx-auto text-sm md:text-base opacity-90 mt-2">
          © 2025 Scucci Systems LLC. All rights reserved. Scucci™ is a trademark.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
